import React from "react"

import BaseSvgIcon from "../Base"

const ArrowPointerSolid = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M6.49777 2.49381C6.80152 2.34006 7.16902 2.37381 7.43902 2.58006L19.439 11.5763C19.7503 11.8088 19.874 12.2138 19.754 12.5813C19.634 12.9488 19.289 13.1963 18.899 13.1963H13.1878L16.5215 19.8601C16.8178 20.4526 16.5778 21.1726 15.9853 21.4688C15.3928 21.7651 14.6728 21.5251 14.3765 20.9326L11.0428 14.2688L7.61902 18.8363C7.38652 19.1476 6.98152 19.2713 6.61402 19.1513C6.24652 19.0313 5.99902 18.6863 5.99902 18.3001V3.30006C5.99902 2.95881 6.19027 2.64756 6.49777 2.49381Z"
        fill="white"
      />
    </BaseSvgIcon>
  )
}

export default ArrowPointerSolid
